export default "__VITE_ASSET__D9b2snZy__"